import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Counter = ({ to = 100, suffix = "", duration = 1.8 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const startTime = performance.now();
    const tick = (now) => {
      const elapsed = (now - startTime) / 1000;
      const progress = Math.min(elapsed / duration, 1);
      // ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(start + (to - start) * eased));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to, duration]);

  return (
    <motion.span
      ref={ref}
      className="tabular-nums"
      whileHover={{ rotateX: 12, rotateY: -8, scale: 1.05 }}
      style={{ display: "inline-block", transformStyle: "preserve-3d" }}
    >
      {value}
      {suffix}
    </motion.span>
  );
};
